module.exports = __webpack_public_path__ + "friday.2f7b993eccd2a1e8aaaa.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/friday.eot?o83v8v
// module id = 513
// module chunks = 0